export const ACTION_TYPES = {
  
    setLoader: 'LOADSET',
    setMonthlyLoader: 'LOADSET_MONTHLY',
    getHotels:'GET_HOTEL'
    
  };
  